import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';

const GetReviewProof = lazy(() => import('../container/externalReviewProof/ExternalReviewProof'));

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  return (
    <Routes>
      {/* Wrap with Page inside element */}
      <Route index element={<GetReviewProof />} />
      {/* <Route path="external" element={<GetReviewProof />} /> */}
    </Routes>
  );
});

export default AuthLayout(FrontendRoutes);
